module.exports = __webpack_public_path__ + "images/emoji/flags.8651e12df84f2f70914e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/flags.png
// module id = HgRR
// module chunks = 1